<template>
  <div class="videoTrainingManage">
    <template v-if="detailsInfo.length > 0">
      <materialItem v-for="el in detailsInfo" :key="el.id" :info="videoInfo" :item="item" >
        <template #listRight>
          <div @click="toSeeVideo(el, 'videoUrl')" class="right-title hand">{{ el.videoName }}</div>
          <div class="right-item">
            <span>采用脚本ID：</span>
            <span>{{ el.laowuId }}</span>
          </div>
          <div class="right-item">
            <span>训练完成时间：</span>
            <span>{{$initTime(el.videoUploadTime, 'yyyy-MM-DD HH:mm')}}</span>
          </div>
          <div class="right-item">
            <span>数字人ID：</span>
            <span>{{ el.id }}-{{ userId }}-{{ setPinyin }}</span>
          </div>
          <div class="right-item right-span">
            <span>审核状态：{{ statusMap[el.serviceStatus] }}</span>
            <span v-if="el.serviceCheckTime">审核时间：{{ $initTime(el.serviceCheckTime, 'yyyy-MM-DD HH:mm') }}</span>
          </div>
          <div class="right-item" v-if="el.serviceStatus === 4">
            <span>原因：</span>
            <span>{{ el.serviceRemarks }}</span>
          </div>
          <div class="right-button" v-if="el.serviceStatus === 2">
            <el-button type="primary" @click="handleDetails(el)" size="mini" icon="el-icon-check">通过</el-button>
            <el-button type="danger" @click="handleNotExamine(el)" plain size="mini" icon="el-icon-close">驳回再训练</el-button>
            <span>说明：7日内您可以驳回；超时将自动视为通过</span>
          </div>
        </template>
      </materialItem>
    </template>
    <placeholder :isShow="true" content="AI训练结果待上传" v-else />
    <notPassDialog :notPassDialogShow.sync="notPassDialogShow" :verified="4" @handleExamine="handleExamine" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { pinyin } from 'pinyin-pro'
import materialItem from './materialItem.vue'
import notPassDialog from './notPassDialog.vue'
import { getVideoTraining, updateVideoTraining } from '@/api/mySciencePopularization.js'
// import { addLaowuServiceRecord } from '@/api/aigcServices.js'

export default {
  props: {
    detailsId: {
      type: Number,
      default: null
    }
  },
  components: {
    materialItem,
    notPassDialog
  },
  data () {
    return {
      list: [],
      uploadlist: [{
        id: 0
      }, {
        id: 1
      }, {
        id: 2
      }],
      item: {
        id: 0,
        trueName: ''
      },
      detailsInfo: [],
      details: {},
      statusMap: ['待上传', '已上传', '待审核', '审核通过', '专家驳回'],
      videoInfo: {
        iconName: 'el-icon-video-camera',
        title: '视频',
        type: 'video',
        format: 'MP4/MOV',
        attention: '',
        guide: '录制指南：面部清晰无遮挡',
        guideIcon: 'el-icon-info',
        accept: 'video/mp4,video/quicktime'
      },
      notPassDialogShow: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'userId']),
    setPinyin () {
      return pinyin(this.userInfo.trueName, { toneType: 'none', separator: '' })
    }
  },

  methods: {
    handleNotExamine (el) {
      this.details = el
      this.notPassDialogShow = true
    },
    handleDetails (el) {
      this.details = el
      this.handleExamine(3)
    },
    handleExamine (serviceStatus, serviceRemarks = '') {
      this.$confirm('提交后不可修改, 是否继续?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await updateVideoTraining({
            id: this.details.id,
            laowuId: this.details.laowuId,
            serviceStatus,
            serviceCheckTime: new Date().getTime(),
            serviceRemarks
          })
          // await addLaowuServiceRecord({
          //   laowuId: [item.laowuId],
          //   verify: serviceStatus === 3 ? 8 : 9,
          //   verifiedRecord: this.statusMap[serviceStatus]
          // })
          this.notPassDialogShow = false
          this.getVideoTraining()
          this.$message.success('操作成功')
        } catch (error) {
          this.$message.error(error)
        }
      }).catch((e) => {
      })
    },
    async getVideoTraining () {
      try {
        const { data } = await getVideoTraining({
          id: this.detailsId
        })
        this.detailsInfo = data
      } catch (error) {
        this.$message.error(error)
      }
    },
    toSeeVideo (video, type) {
      if (!this.userInfo.userId) {
        return this.$login()
      }
      sessionStorage.setItem('videoObj', JSON.stringify({
        videoId: video.id,
        videoUrl: video[type],
        modularType: 'video',
        tabActive: 1
      }))
      this.$router.push('/videoDetails')
    }
  },
  created () {
    this.getVideoTraining()
    this.item.trueName = JSON.parse(window.localStorage.getItem('userInfo')).trueName
  }
}
</script>
<style lang="less" scoped>
.videoTrainingManage {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
